/*!
 * Good Boy Vodka — Big Thirst Cart Config
 *
 * Brand-specific config for the Big Thirst Cart engine.
 * Hosted on goodboyvodka.myshopify.com Content > Files.
 *
 * WordPress setup (Code Snippets plugin, HTML type, site-wide header):
 *   <script src="https://goodboyvodka.myshopify.com/cdn/shop/files/goodboy-config.js"></script>
 *
 *   On the shop page, add where the collection should render:
 *   <div id="bt-collection"></div>
 */

window.__BT_GOODBOY_CONFIG_VERSION = '2026-03-27-01';
console.info('[Good Boy Config]', window.__BT_GOODBOY_CONFIG_VERSION);

window.BigThirstCartConfig = {
  // Good Boy's own Shopify store
  domain: 'goodboyvodka.myshopify.com',
  storefrontAccessToken: '80df18e93e0872cc293877db26a8c2e5',

  // Collection
  collectionHandle: 'all-spirits',

  // Tracking
  gtmId: 'GTM-N9XJR2LG',

  // Collection / button copy
  buyButtonText: 'BUY NOW',

  // Inventory display
  showInventory: true,
  inventoryThreshold: 15,
  inventoryInStockText: 'In Stock',

  // Cart copy
  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax &amp; shipping calculated in next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: 'Discounts/Promo Codes Added During Checkout',
  cartNoteLabel: 'Order Note or Personalized Note for Recipient',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  // Fonts
  googleFonts: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap',

  // CSS custom properties (brand theming — matches existing Buy Button SDK styling)
  cssVars: [
    '--bt-font: "Roboto", sans-serif;',
    '--bt-price-color: #215a3f;',
    '--bt-price-size: 22px;',
    '--bt-text-color: #7a7a7a;',
    '--bt-title-size: 20px;',
    '--bt-title-weight: normal;',
    '--bt-title-margin: 8px;',
    '--bt-title-min-height: 55px;',
    '--bt-description-color: #7a7a7a;',
    '--bt-border-color: #7a7a7a;',
    '--bt-btn-bg: #ffffff;',
    '--bt-btn-color: #7a7a7a;',
    '--bt-btn-hover-bg: #d8d500;',
    '--bt-btn-hover-color: #000000;',
    '--bt-btn-px: 30px;',
    '--bt-btn-radius: 0;',
    '--bt-add-btn-size: 20px;',
    '--bt-grid-gap: 30px;',
    '--bt-grid-bottom: 50px;',
    '--bt-toggle-icon-color: #7a7a7a;',
    '--bt-toggle-count-color: #7a7a7a;',
    '--bt-notice-bold-color: #000;',
    '--bt-notice-link-color: #215a3f;',
  ].join(' '),

  customCSS: [
    '#bt-collection { font-family: "Roboto", sans-serif; }',
    '#bt-collection .bt-products { display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 30px; max-width: 1200px; margin: 0 auto !important; }',
    '#bt-collection .bt-product { width: auto !important; margin: 0 !important; border: 1px solid #7a7a7a; border-radius: 10px; padding: 6px; min-width: 0; box-sizing: border-box; display: grid; grid-template-columns: 1fr auto auto 1fr; grid-template-rows: 360px minmax(110px, auto) auto 22px 73px auto; justify-content: stretch; align-content: start; text-align: center; }',
    '#bt-collection .bt-product > img { grid-column: 1 / -1; grid-row: 1; width: 100%; height: 340px; object-fit: contain; display: block; margin: 0 auto 10px; }',
    '#bt-collection .bt-product-title { grid-column: 1 / -1; grid-row: 2; width: 100%; min-height: 110px; margin: 0; font-size: 23px !important; line-height: 32px !important; text-align: center; display: flex; align-items: flex-start; justify-content: center; color: #333 !important; }',
    '#bt-collection .bt-product-price { grid-column: 1 / -1; grid-row: 3; width: 100%; text-align: center; margin: 0; font-family: Roboto, sans-serif !important; font-size: 40px !important; font-weight: bold !important; line-height: 1.5em !important; color: #215a3f !important; }',
    '#bt-collection .bt-inventory { grid-column: 1 / -1; grid-row: 4; width: 100%; min-height: 22px; text-align: center; margin: 0; }',
    '#bt-collection .bt-product > .bt-qty-wrap { grid-column: 2; grid-row: 5; display: flex; align-items: stretch; justify-content: stretch; width: 60px; height: 73px; margin: 0 !important; }',
    '#bt-collection .bt-product > .bt-add-btn { grid-column: 3; grid-row: 5; margin: 0 !important; }',
    '#bt-collection .bt-actions { grid-column: 2 / span 2; grid-row: 5; display: inline-flex; align-items: stretch; justify-content: center; margin: 0 auto !important; width: auto; }',
    '#bt-collection .bt-actions .bt-qty-wrap { display: flex; align-items: stretch; margin: 0 !important; width: 60px; height: 73px; }',
    '#bt-collection .bt-actions .bt-add-btn { margin: 0 !important; }',
    '#bt-collection .bt-product-description { grid-column: 1 / -1; grid-row: 6; width: 100%; margin: 30px 0 0; line-height: 1.65; color: #7a7a7a !important; text-align: center; }',
    '#bt-collection .bt-qty-btn { display: none; }',
    '#bt-collection .bt-qty-input { width: 60px !important; min-width: 60px; height: 73px; min-height: 73px; padding: 0; border: 1px solid #7a7a7a; border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important; font-size: 18px; line-height: 73px; background: #fff; color: #7a7a7a; margin: 0 !important; box-sizing: border-box; text-align: center; }',
    '#bt-collection .bt-add-btn { display: inline-flex; align-items: center; justify-content: center; width: 190px !important; min-width: 190px; max-width: 190px; height: 73px; min-height: 73px; padding: 0 12px !important; font-size: 25px !important; font-weight: 700; line-height: 1; color: #7a7a7a; background: #fff; border: 5px solid #c6d739 !important; border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important; text-transform: none; letter-spacing: 0.3px; box-sizing: border-box; }',
    '#bt-collection .bt-add-btn:hover, #bt-collection .bt-add-btn:focus { background: #d8d500; color: #000; }',
    '#bt-cart-toggle { text-align: center; padding: 2px 10px; box-shadow: 0 0 20px 0 rgba(115,115,115,1); color: #000; background: #fff; }',
    '#bt-cart-toggle:hover, #bt-cart-toggle:focus { background: #e6e6e6; }',
    '#bt-cart-toggle svg { width: 25px; height: 25px; }',
    '#bt-cart-drawer .bt-cart-title { font-size: 28px; line-height: 1.1; }',
    '#bt-cart-drawer .bt-line-item-controls { align-items: center; gap: 0; }',
    '#bt-cart-drawer .bt-line-qty-btn { width: 28px; height: 28px; border: 1px solid #7a7a7a; color: #555; background: #fff; font-size: 16px; }',
    '#bt-cart-drawer .bt-line-dec { border-right: 0; }',
    '#bt-cart-drawer .bt-line-inc { border-left: 0; }',
    '#bt-cart-drawer .bt-line-qty { width: 36px; height: 28px; border: 1px solid #7a7a7a; border-left: 0; border-right: 0; color: #333; font-weight: 700; background: #fff; }',
    '#bt-cart-drawer .bt-line-remove { margin-left: 12px; font-size: 11px; color: #7a7a7a; text-transform: uppercase; letter-spacing: 0.08em; text-decoration: none; border: 1px solid #d8d500; padding: 6px 10px; }',
    '#bt-cart-drawer .bt-line-remove:hover { color: #000; background: #d8d500; }',
    '#bt-cart-drawer .bt-checkout-btn { font-size: 20px; font-weight: 700; background: #fff; color: #7a7a7a; border: 1px solid #7a7a7a; text-transform: none; letter-spacing: 0.3px; }',
    '#bt-cart-drawer .bt-checkout-btn:hover, #bt-cart-drawer .bt-checkout-btn:focus { background: #d8d500; color: #000; }',
    '@media only screen and (max-width: 900px) { #bt-collection .bt-products { grid-template-columns: repeat(2, minmax(0, 1fr)); } }',
    '@media only screen and (max-width: 600px) { #bt-collection .bt-products { grid-template-columns: 1fr; max-width: 400px; } #bt-collection .bt-product { max-width: 100%; } }',
  ].join('\n'),
};

// Load the Big Thirst Cart engine
(function () {
  var s = document.createElement('script');
  s.src = 'https://goodboyvodka.myshopify.com/cdn/shop/files/bigthirst-cart.js';
  s.async = true;
  document.head.appendChild(s);
})();
